var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#whatsapp_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.592.435c8.01 1.976 12.948 10.146 10.973 18.157-1.976 8.01-10.146 12.948-18.157 10.973C3.397 27.588-1.541 19.418.435 11.407 2.411 3.398 10.581-1.54 18.592.435Z",
  fill: "#52D131"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.873 14.23c.42-.834.565-1.771.082-2.618-.186-.327-.473-.69-.85-.797-.39-.11-.88-.032-1.034.342-.122.298-.676 1.537-.696 1.74a.35.35 0 0 0 .038.197c.17.337.602.73.663.893a.284.284 0 0 1-.038.255c-.63 1.093-1.864 2.264-2.987 2.837a.285.285 0 0 1-.257.026c-.16-.07-.53-.521-.858-.709a.357.357 0 0 0-.195-.048c-.205.011-1.47.5-1.773.607-.383.134-.486.62-.395 1.014.087.383.435.687.752.89.818.526 1.764.429 2.618.053 1.814-.794 4.024-2.876 4.93-4.682Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.831 22.437a7.635 7.635 0 0 0 4.225-1.27l2.95.944-.958-2.85a7.64 7.64 0 0 0 1.462-4.503c0-4.233-3.445-7.678-7.679-7.678s-7.678 3.445-7.678 7.678c0 4.233 3.444 7.679 7.678 7.679Zm0-16.812a9.136 9.136 0 0 1 7.823 13.85l1.65 4.898-5.056-1.618a9.133 9.133 0 1 1-4.414-17.132l-.003.002Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "whatsapp_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "matrix(-1 0 0 1 30 0)",
  d: "M0 0h30v30H0z"
})))));
export default SvgWhatsapp;